import { useCallback, useState } from 'react'
import { sleep } from '../utilities/general'

type ClipboardOptions = {
  copiedTimeout?: number
}

const useClipboard = (options: ClipboardOptions = {}) => {
  const { copiedTimeout = 1500 } = options
  const [copied, setCopied] = useState(false)

  const copy = useCallback(
    async (copyValue: string | number) => {
      if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(copyValue.toString())
        setCopied(true)
        await sleep(copiedTimeout)
        setCopied(false)
      } else {
        console.error('Clipboard API not supported')
      }
    },
    [copiedTimeout]
  )

  return { copy, copied }
}

export default useClipboard
